import { create } from 'zustand';
import { AlertColor } from '@mui/material/Alert';

interface Alert {
  message: string;
  severity: AlertColor;
  duration?: number;
}

interface AlertState {
  alert: Alert | null;
  showAlert: (message: string, severity: AlertColor, duration?: number) => void;
  clearAlert: () => void;
}

const useAlert = create<AlertState>((set, get) => {
  let timeoutRef: NodeJS.Timeout | null = null;

  function internalClearTimeout() {
    if (timeoutRef) {
      clearTimeout(timeoutRef)
      timeoutRef = null
    }
  }

  return ({
    alert: null,
    showAlert: (message: string, severity: AlertColor, duration?: number) => {
      internalClearTimeout()
      set(() => ({ alert: { message, severity, duration: duration ?? 3000 } }))
      timeoutRef = setTimeout(() => get().clearAlert(), duration ?? 3000)
    },
    clearAlert: () => {
      internalClearTimeout()
      set(() => ({ alert: null }))
    },
  })
});

export default useAlert;
